
<template>
    <div>
            
    <div type="dismissible" class="mcc-drawer mcc-drawer--end end-drawer--adjust mcc-drawer-w-fixed" ref="rightdrawer">
        <div class="mcc-drawer__content">
            <nav class="mcc-menu">
            <div class="mcc-navigation-header--fixed-adjust"></div>
        <div class="mu-m-03">
    <div v-if="showCategories">
        <div class="mu-fw-bold">Categories
</div>
<DrilldownItem :nodes="categories"></DrilldownItem>
<button class="mcc-menu__button" title="Hide" @click="closeRightContainer">
<mcc-icon name="cancel" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Hide</span></button>
    </div>
    
</div>
</nav>
</div>
</div>
</div>
</template>
<script>
import NavigationButton from './NavigationButton.vue'
import DrilldownItem from './DrilldownItem.vue'
import {
    EventBus
} from "@/services/event-bus";
export default {
    components: {
        NavigationButton,
        DrilldownItem
    },
    mounted() {
        let self = this;
        self.categories = self.$store.getters.getCategories;

        EventBus.$on("updateCategoriesDrilldown", result => {
            self.categories = {};
            self.showCategories = false;
            setTimeout(() => {
                self.categories = result;
                self.showCategories = true;
            }, 1000);
        });
    },
    created()
    {
        EventBus.$on("openRightDrawer", this.openRightDrawer);
    },
    methods:
    {
        openRightDrawer()
        {
            this.$refs.rightdrawer.classList.add("mcc-drawer--open") 
            this.$store.commit('setEndDrawerStatus', true);
        },
        closeRightContainer()
        {
            this.$refs.rightdrawer.classList.remove("mcc-drawer--open") 
            this.$store.commit('setEndDrawerStatus', false);

        }
    },
    data() {
        return {
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            categories: {},
            showCategories: true,
        }
    }
}
</script>
<style scoped>


</style>

